import { render } from "./FileItem.vue?vue&type=template&id=6439deb8&scoped=true"
import script from "./FileItem.vue?vue&type=script&lang=js"
export * from "./FileItem.vue?vue&type=script&lang=js"

import "./FileItem.vue?vue&type=style&index=0&id=6439deb8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6439deb8"]])

export default __exports__